import { render, staticRenderFns } from "./broadcast-form.vue?vue&type=template&id=376d9652&"
import script from "./broadcast-form.vue?vue&type=script&lang=js&"
export * from "./broadcast-form.vue?vue&type=script&lang=js&"
import style0 from "./broadcast-form.vue?vue&type=style&index=0&id=376d9652&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports